import { useState } from 'react';

import { css } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { Adg4Button } from '@/components/adg4/button/src/button';
import TryIntent from '@/components/try-intent/src/try-intent';
import { Ai } from '@/patterns/adg4/ai-section/src/ai';
import { YoutubeModal } from '@/patterns/modal/src/youtube-modal';
import { useScrollTracking } from '@/utils/scroll-tracking/scroll-tracking';

const AISection = () => {
	const intl = useIntl();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { ref } = useScrollTracking('AISection', {
		observerOptions: {
			threshold: 0.25,
		},
	});

	return (
		<UFOSegment name="confluence-pt-cfind-1234-aiSection">
			<div
				ref={ref}
				css={css({
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
					'.video-container': {
						height: '407px',
						padding: '0px 54px',
					},
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
					'.burst-container1': {
						position: 'absolute',
						insetInlineStart: '10%',
					},
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
					'.burst-container2': {
						position: 'absolute',
						insetInlineEnd: '50px',
					},
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
					'.video': {
						height: 'auto',
						padding: '0px 109px',
					},
				})}
			>
				<Ai
					theme="light"
					title={intl.formatMessage({
						id: 'ConfluenceSoftwarePage.v4.AISection.title',
						defaultMessage: 'Leave the busywork to AI',
					})}
					videoLink="https://dam-cdn.atl.orangelogic.com/AssetLink/50m38s3ne34430160w3lr4jcg67ykb0t.mp4"
					includeFooter={false}
					button={
						<TryIntent
							intentType={'button'}
							containerId={'aiSection'}
							productKey={'confluence'}
							edition={'free'}
						>
							<Adg4Button
								variant="secondary"
								color="black"
								size="large"
								dataEventProps={{
									'data-product-key': 'confluence',
									'data-event': 'clicked',
									'data-event-component': 'linkButton',
									'data-event-container': 'aiSection',
									'data-label': 'explore-atlassian-intelligence',
									'data-label-english': 'Explore Atlassian Intelligence',
									'data-track-event': 'confluence-pt.ai.explore-atlassian-intelligence',
								}}
								onClick={() => setIsModalOpen(true)}
							>
								<FormattedMessage
									id="ConfluenceSoftwarePage.v4.AISection.button"
									defaultMessage="Explore Atlassian Intelligence"
								/>
							</Adg4Button>
						</TryIntent>
					}
					buttonPosition="bottom"
					videoContainerClassName={'video-container'}
					showBurst={true}
					burstClassName1={'burst-container1'}
					burstClassName2={'burst-container2'}
					videoClassName={'video'}
				/>
				<YoutubeModal
					isOpen={isModalOpen}
					closeModal={() => setIsModalOpen(false)}
					src="https://www.youtube.com/embed/ivIV1a8W0e4?si=iNOFdEMuDzTKN4X_?autoplay=1&amp;rel=0&amp;origin=https%3A%2F%2Fwww.atlassian.com&amp;widget_referrer=https%3A%2F%2Fwww.atlassian.com&amp;enablejsapi=1&amp;widgetid=1&autoplay=1"
					title={intl.formatMessage({
						id: 'ConfluenceSoftwarePage.v4.AISection.ModalYouTubeIframeTitle',
						defaultMessage: 'Empower Teams with Atlassian Intelligence in Confluence | Atlassian',
					})}
					closeIconLabel={intl.formatMessage({
						id: 'ConfluenceSoftwarePage.v4.AISection.CloseModalButtonMobileLabel',
						defaultMessage: 'Close modal',
					})}
				/>
			</div>
		</UFOSegment>
	);
};

AISection.displayName = 'AISection';

export default AISection;
